export default __webpack_public_path__ + "static/media/cif-pa.3aa82dc2.svg";